const e = 10,
	t = 32,
	n = 45,
	s = 48,
	u = 57,
	r = 65,
	o = 92,
	l = 97,
	i = 122,
	a = 128
export const codepointsToTokens = (f, c = 0) => {
	const p = []
	for (; c < f.length; c += 1) {
		const d = f.at(c),
			h = c
		if (47 === d && 42 === f.at(c + 1)) {
			c += 2
			for (let e = f.at(c); void 0 !== e; e = f.at(++c))
				if (42 === e && 47 === f.at(c + 1)) {
					c += 1
					break
				}
		} else if (9 === d || d === t || d === e) {
			let n = f.at(++c)
			for (; 9 === n || n === t || n === e; ) n = f.at(++c)
			c -= 1
			const s = p.at(-1)
			'whitespace' === (null == s ? void 0 : s.type)
				? (p.pop(), p.push({type: 'whitespace', start: s.start, end: c}))
				: p.push({type: 'whitespace', start: h, end: c})
		} else if (34 === d) {
			const e = consumeString(f, c)
			if (null === e) return {errid: 'INVALID_STRING', start: c, end: c}
			const [t, n] = e
			;(c = t), p.push({type: 'string', value: n, start: h, end: c})
		} else if (35 === d) {
			if (c + 1 < f.length) {
				const t = f.at(c + 1)
				if (
					95 === t ||
					(t >= r && t <= 90) ||
					(t >= l && t <= i) ||
					t >= a ||
					(t >= s && t <= u) ||
					(t === o && c + 2 < f.length && f.at(c + 2) !== e)
				) {
					const e = wouldStartIdentifier(f, c + 1) ? 'id' : 'unrestricted',
						t = consumeIdentUnsafe(f, c + 1)
					if (null !== t) {
						const [n, s] = t
						;(c = n), p.push({type: 'hash', value: s.toLowerCase(), flag: e, start: h, end: c})
						continue
					}
				}
			}
			p.push({type: 'delim', value: d, start: h, end: c})
		} else if (39 === d) {
			const e = consumeString(f, c)
			if (null === e) return {errid: 'INVALID_STRING', start: c, end: c}
			const [t, n] = e
			;(c = t), p.push({type: 'string', value: n, start: h, end: c})
		} else if (40 === d) p.push({type: '(', start: h, end: c})
		else if (41 === d) p.push({type: ')', start: h, end: c})
		else if (43 === d) {
			const e = consumeNumeric(f, c)
			if (null === e) p.push({type: 'delim', value: d, start: h, end: c})
			else {
				const [t, n] = e
				;(c = t),
					'dimension' === n[0]
						? p.push({
								type: 'dimension',
								value: n[1],
								unit: n[2].toLowerCase(),
								flag: 'number',
								start: h,
								end: c
						  })
						: 'number' === n[0]
						? p.push({type: n[0], value: n[1], flag: n[2], start: h, end: c})
						: p.push({type: n[0], value: n[1], flag: 'number', start: h, end: c})
			}
		} else if (44 === d) p.push({type: 'comma', start: h, end: c})
		else if (d === n) {
			const e = consumeNumeric(f, c)
			if (null !== e) {
				const [t, n] = e
				;(c = t),
					'dimension' === n[0]
						? p.push({
								type: 'dimension',
								value: n[1],
								unit: n[2].toLowerCase(),
								flag: 'number',
								start: h,
								end: c
						  })
						: 'number' === n[0]
						? p.push({type: n[0], value: n[1], flag: n[2], start: h, end: c})
						: p.push({type: n[0], value: n[1], flag: 'number', start: h, end: c})
				continue
			}
			if (c + 2 < f.length) {
				const e = f.at(c + 1),
					t = f.at(c + 2)
				if (e === n && 62 === t) {
					;(c += 2), p.push({type: 'CDC', start: h, end: c})
					continue
				}
			}
			const t = consumeIdentLike(f, c)
			if (null !== t) {
				const [e, n, s] = t
				;(c = e), p.push({type: s, value: n, start: h, end: c})
				continue
			}
			p.push({type: 'delim', value: d, start: h, end: c})
		} else if (46 === d) {
			const e = consumeNumeric(f, c)
			if (null !== e) {
				const [t, n] = e
				;(c = t),
					'dimension' === n[0]
						? p.push({
								type: 'dimension',
								value: n[1],
								unit: n[2].toLowerCase(),
								flag: 'number',
								start: h,
								end: c
						  })
						: 'number' === n[0]
						? p.push({type: n[0], value: n[1], flag: n[2], start: h, end: c})
						: p.push({type: n[0], value: n[1], flag: 'number', start: h, end: c})
				continue
			}
			p.push({type: 'delim', value: d, start: h, end: c})
		} else if (58 === d) p.push({type: 'colon', start: h, end: c})
		else if (59 === d) p.push({type: 'semicolon', start: h, end: c})
		else if (60 === d) {
			if (c + 3 < f.length) {
				const e = f.at(c + 1),
					t = f.at(c + 2),
					s = f.at(c + 3)
				if (33 === e && t === n && s === n) {
					;(c += 3), p.push({type: 'CDO', start: h, end: c})
					continue
				}
			}
			p.push({type: 'delim', value: d, start: h, end: c})
		} else if (64 === d) {
			const e = consumeIdent(f, c + 1)
			if (null !== e) {
				const [t, n] = e
				;(c = t), p.push({type: 'at-keyword', value: n.toLowerCase(), start: h, end: c})
				continue
			}
			p.push({type: 'delim', value: d, start: h, end: c})
		} else if (91 === d) p.push({type: '[', start: h, end: c})
		else if (93 === d) p.push({type: ']', start: h, end: c})
		else if (123 === d) p.push({type: '{', start: h, end: c})
		else if (125 === d) p.push({type: '}', start: h, end: c})
		else if (d >= s && d <= u) {
			const e = consumeNumeric(f, c),
				[t, n] = e
			;(c = t),
				'dimension' === n[0]
					? p.push({
							type: 'dimension',
							value: n[1],
							unit: n[2].toLowerCase(),
							flag: 'number',
							start: h,
							end: c
					  })
					: 'number' === n[0]
					? p.push({type: n[0], value: n[1], flag: n[2], start: h, end: c})
					: p.push({type: n[0], value: n[1], flag: 'number', start: h, end: c})
		} else if (95 === d || (d >= r && d <= 90) || (d >= l && d <= i) || d >= a || d === o) {
			const e = consumeIdentLike(f, c)
			if (null === e) p.push({type: 'delim', value: d, start: h, end: c})
			else {
				const [t, n, s] = e
				;(c = t), p.push({type: s, value: n, start: h, end: c})
			}
		} else p.push({type: 'delim', value: d, start: h, end: c})
	}
	return p.push({type: 'EOF', start: c, end: c}), p
}
export const consumeString = (t, n) => {
	if (t.length <= n + 1) return null
	const s = t.at(n),
		u = []
	for (let r = n + 1; r < t.length; r += 1) {
		const n = t.at(r)
		if (n === s) return [r, String.fromCodePoint(...u)]
		if (n === o) {
			const e = consumeEscape(t, r)
			if (null === e) return null
			const [n, s] = e
			u.push(s), (r = n)
		} else {
			if (n === e) return null
			u.push(n)
		}
	}
	return null
}
export const wouldStartIdentifier = (t, s) => {
	const u = t.at(s)
	if (void 0 === u) return !1
	if (u === n) {
		const u = t.at(s + 1)
		if (void 0 === u) return !1
		if (u === n || 95 === u || (u >= r && u <= 90) || (u >= l && u <= i) || u >= a) return !0
		if (u === o) {
			if (t.length <= s + 2) return !1
			return t.at(s + 2) !== e
		}
		return !1
	}
	if (95 === u || (u >= r && u <= 90) || (u >= l && u <= i) || u >= a) return !0
	if (u === o) {
		if (t.length <= s + 1) return !1
		return t.at(s + 1) !== e
	}
	return !1
}
export const consumeEscape = (n, i) => {
	if (n.length <= i + 1) return null
	if (n.at(i) !== o) return null
	const a = n.at(i + 1)
	if (a === e) return null
	if ((a >= s && a <= u) || (a >= r && a <= 70) || (a >= l && a <= 102)) {
		const o = [a],
			f = Math.min(i + 7, n.length)
		let c = i + 2
		for (; c < f; c += 1) {
			const e = n.at(c)
			if (!((e >= s && e <= u) || (e >= r && e <= 70) || (e >= l && e <= 102))) break
			o.push(e)
		}
		if (c < n.length) {
			const s = n.at(c)
			;(9 !== s && s !== t && s !== e) || (c += 1)
		}
		return [c - 1, Number.parseInt(String.fromCodePoint(...o), 16)]
	}
	return [i + 1, a]
}
export const consumeNumeric = (e, t) => {
	const n = consumeNumber(e, t)
	if (null === n) return null
	const [s, u, r] = n,
		o = consumeIdent(e, s + 1)
	if (null !== o) {
		const [e, t] = o
		return [e, ['dimension', u, t]]
	}
	return s + 1 < e.length && 37 === e.at(s + 1) ? [s + 1, ['percentage', u]] : [s, ['number', u, r]]
}
export const consumeNumber = (e, t) => {
	const r = e.at(t)
	if (void 0 === r) return null
	let o = 'integer'
	const l = []
	for ((43 !== r && r !== n) || ((t += 1), r === n && l.push(n)); t < e.length; ) {
		const n = e.at(t)
		if (!(n >= s && n <= u)) break
		l.push(n), (t += 1)
	}
	if (t + 1 < e.length) {
		const n = e.at(t),
			r = e.at(t + 1)
		if (46 === n && r >= s && r <= u)
			for (l.push(n, r), o = 'number', t += 2; t < e.length; ) {
				const n = e.at(t)
				if (!(n >= s && n <= u)) break
				l.push(n), (t += 1)
			}
	}
	if (t + 1 < e.length) {
		const r = e.at(t),
			i = e.at(t + 1),
			a = e.at(t + 2)
		if (69 === r || 101 === r) {
			let r = !1
			if (
				(i >= s && i <= u
					? (l.push(69, i), (t += 2), (r = !0))
					: (i === n || 43 === i) &&
					  void 0 !== a &&
					  a >= s &&
					  a <= u &&
					  (l.push(69), i === n && l.push(n), l.push(a), (t += 3), (r = !0)),
				r)
			)
				for (o = 'number'; t < e.length; ) {
					const n = e.at(t)
					if (!(n >= s && n <= u)) break
					l.push(n), (t += 1)
				}
		}
	}
	const i = String.fromCodePoint(...l)
	let a = 'number' === o ? Number.parseFloat(i) : Number.parseInt(i)
	return 0 === a && (a = 0), Number.isNaN(a) ? null : [t - 1, a, o]
}
export const consumeIdentUnsafe = (e, t) => {
	if (e.length <= t) return null
	const o = []
	for (let f = e.at(t); t < e.length; f = e.at(++t)) {
		if (
			!(
				f === n ||
				95 === f ||
				(f >= r && f <= 90) ||
				(f >= l && f <= i) ||
				f >= a ||
				(f >= s && f <= u)
			)
		) {
			{
				const n = consumeEscape(e, t)
				if (null !== n) {
					const [e, s] = n
					o.push(s), (t = e)
					continue
				}
			}
			break
		}
		o.push(f)
	}
	return 0 === t ? null : [t - 1, String.fromCodePoint(...o)]
}
export const consumeIdent = (e, t) => (wouldStartIdentifier(e, t) ? consumeIdentUnsafe(e, t) : null)
export const consumeUrl = (n, s) => {
	let u = n.at(s)
	for (; 9 === u || u === t || u === e; ) u = n.at(++s)
	const r = []
	let l = !1
	for (; s < n.length; ) {
		if (41 === u) return [s, String.fromCodePoint(...r)]
		if (34 === u || 39 === u || 40 === u) return null
		if (9 === u || u === t || u === e) !l && r.length > 0 && (l = !0)
		else if (u === o) {
			const e = consumeEscape(n, s)
			if (null === e || l) return null
			const [t, u] = e
			r.push(u), (s = t)
		} else {
			if (l) return null
			r.push(u)
		}
		u = n.at(++s)
	}
	return null
}
export const consumeIdentLike = (n, s) => {
	const u = consumeIdent(n, s)
	if (null === u) return null
	const [r, o] = u
	if ('url' === o.toLowerCase()) {
		if (n.length > r + 1) {
			if (40 === n.at(r + 1)) {
				for (let s = 2; r + s < n.length; s += 1) {
					const u = n.at(r + s)
					if (34 === u || 39 === u) return [r + 1, o.toLowerCase(), 'function']
					if (9 !== u && u !== t && u !== e) {
						const e = consumeUrl(n, r + s)
						if (null === e) return null
						const [t, u] = e
						return [t, u, 'url']
					}
				}
				return [r + 1, o.toLowerCase(), 'function']
			}
		}
	} else if (n.length > r + 1) {
		if (40 === n.at(r + 1)) return [r + 1, o.toLowerCase(), 'function']
	}
	return [r, o.toLowerCase(), 'ident']
}
